import { AppState } from './../../../interfaces/app-state.interface';
import { FormsEventType, FormsEvents } from './../../../enum/tracking/forms-events.enum';
import { TrackingActions } from './../../../state-management/tracking/tracking.action';
import { FormControl } from '@angular/forms';
import { Input, Directive } from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';
import errorsDefault from '../../../resources/errors.js';
import { Store } from '@ngrx/store';
import * as VMasker from 'vanilla-masker';

// tslint:disable-next-line: interface-name
interface PadOptions {
    length: number;
    pad: string;
}

@Directive()
export class TrInputComponent implements ControlValueAccessor {
    /* VARIABLES */
    @Input() public autocomplete: string = 'off';
    @Input() public innerValue;
    @Input() public label;
    @Input() public observable: any[];
    @Input() public id;
    @Input() public type;
    @Input() public maskDoc;
    @Input() public padValue: string;
    @Input() public padLength: number;
    @Input() public padPosition: 'start' | 'end';
    @Input() public maxLength = '100';
    @Input() public minLength = '0';
    @Input() public maskInput;
    @Input() public tip;
    @Input() public errorMessage: string = 'required';
    @Input() public hint: string;
    @Input() public dataQa = null;
    @Input() public disabled;
    // @Input() ControlReference: FormControl = new FormControl();
    // tslint:disable-next-line: variable-name
    public _referenceControl;

    // tslint:disable-next-line: variable-name
    @Input() set ControlReference(Control: FormControl) {
        this._referenceControl = Control;
        this.ValueInput = Control.value;
        // this._referenceControl.patchValue(this._referenceControl.value);
    }
    get ControlReference() {
        return this._referenceControl;
    }

    public passType = 'password';
    public errors = errorsDefault[this.errorMessage];
    // tslint:disable-next-line: variable-name
    public ValueInput;
    // tslint:disable-next-line: variable-name
    private _telMask;
    // tslint:disable-next-line: variable-name
    private _cpfMask;
    /* VARIABLES */

    constructor(
        private store: Store<AppState>,
    ) { }

    /**
     * Propaga o valor do model interno para o formulário externo
     * @param val value of model
     */
    public onChange(val) {
        this.innerValue = val;
        this.ValueInput = val;
        this.propagateChange(this.innerValue);
        this.ControlReference.setValue(this.innerValue);
        this.bindErrors();
    }

    /**
     * Aplica insere errors no array de errors que será aplicado como alertas
     */
    public bindErrors() {

        this.errors = '';
        let key;
        const controls = this.ControlReference.parent.controls;
        const controlName = Object.keys(controls)
            .find((nameControl) => this.ControlReference === controls[nameControl]) || null;

        // tslint:disable-next-line: prefer-const
        key = null;
        for (key in this.ControlReference.errors) {
            if (this.ControlReference.errors.hasOwnProperty(key)) {
        
                switch (key) {
                    case 'customSpecialCharacterValidation':
                        this.errors = errorsDefault.customSpecialCharacterValidation[this.id.replace(/_[0-9]+/, '')];
                        break;
                    case 'pattern':
                        this.errors = errorsDefault.pattern[this.id.replace(/_[0-9]+/, '')];
                        break;
                    case 'minlength':
                        this.errors = errorsDefault.minlength[this.id];
                        break;
                    case 'required':
                        this.errors = (this.errorMessage !== 'required') ? this.errorMessage : errorsDefault[key];
                        break;
                    case 'backendError':
                        const backendError = this.ControlReference.errors.backendError;
                        this.errors = backendError ? backendError.message : null;
                        break;
                    default:
                        this.errors = errorsDefault[key];
                        break;
                }
            }
        }

        // Track dos erros com GA/GTM
        const event = FormsEvents[controlName] || this.errors;

        if (!['required'].includes(key) && event && this.ControlReference.touched) {
            this.trackFormEvent(event);
        }

    }

    /**
     * Get/Set valor interno do model
     */
    private get value(): any {
        return this.innerValue;
    }
    private set value(v: any) {
        if (v !== this.innerValue) {
            this.innerValue = v;
        }
    }

    /**
     * Propaga mudanças para componentes externos
     */
    public propagateChange = (_: any) => { /** */ };

    /**
     * Método da interface ControlValueAccessor
     * @param value Valor para ser escrito
     */
    public writeValue(value: any) {
        this.innerValue = value;
    }

    /**
     * Registra a função de propagação
     * @param fn Função de propagação
     */
    public registerOnChange(fn: any) {
        this.propagateChange = fn;
    }

    /**
     * Marcar campo externo como tocado no blur do input
     */
    public registerOnTouched() {
        this.ControlReference.markAsTouched({ onlySelf: true });
        this.bindErrors();
    }

    public ngOnInit() {

        this.ControlReference.valueChanges.subscribe((e) => {
            this.ValueInput = e;
        });

        this.ControlReference.statusChanges.subscribe(() => {
            this.bindErrors();
        });
    }

    public ngAfterViewInit() { /** */ }

    public setValueInput(val: number | string) {
        this.ValueInput = val;
    }

    private trackFormEvent(event: string) {

        const eventParsed = event
            .toLowerCase()
            .normalize('NFD')
            .replace(/ /g, '_')
            .replace(/[\u0300-\u036f]/g, '');

        this.store.dispatch({
            type: TrackingActions.trackFormEvent,
            payload: {
                type: FormsEventType.Error,
                event: eventParsed,
            },
        });

    }
}
